import React from "react";
import { playIcon } from "../../../constants/icons";
import LinkWrapper from "../../LinkWrapper";

function CoursePlaySlot({ className, courseTitle, courseTime }) {
  return (
    <div className={`${className || ""} d-flex justify-content-between`}>
      <LinkWrapper
        href="#"
        className="course-list text-decoration-none "
      >
        <div className="course-icon-title d-flex align-items-center gap-2">
          <span>{playIcon}</span>
          <p className="mb-0">{courseTitle}</p>
        </div>
      </LinkWrapper>
      <div className="d-flex align-items-center gap-3">
        <LinkWrapper
          href="javascript:void(0)"
          className="course-list d-flex justify-content-between"
        >
          Preview
        </LinkWrapper>
        <span>{courseTime}</span>
      </div>
    </div>
  );
}

export default CoursePlaySlot;
